import src from "IMAGE";
export default { src, width: 2490, height: 1600, blurWidth: 0, blurHeight: 0};
